<template>
  <div class="rules-group-container">
    <div class="rules-group-header">
      <div class="btn-group pull-right group-actions">
        <el-button-group>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addRule"
            >条件</el-button
          >
          <el-button
            size="mini"
            type="success"
            icon="el-icon-plus"
            v-if="this.depth < this.maxDepth"
            @click="addGroup"
            >组</el-button
          >
          <el-button
            v-if="this.depth > 1"
            @click="remove"
            size="mini"
            style="background-color: #f56c6c; border-color: #f56c6c;color: #FFFFFF;"
            icon="el-icon-close"
          ></el-button>
        </el-button-group>
      </div>
      <div>
        <el-radio-group v-model="query.logicalOperator" size="mini">
          <el-radio-button type="primary" label="AND">并且</el-radio-button>
          <el-radio-button type="primary" label="OR">或者</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="rules-group-body">
      <div class="rules-list">
        <component
          v-for="(child, index) in query.children"
          :key="index"
          :is="child.type"
          :id="generateUUIDv4()"
          :type="child.type"
          :query.sync="child.query"
          :ruleTypes="ruleTypes"
          :rules="rules"
          :items="slots"
          :index="index"
          :customItems="customItems"
          :maxDepth="maxDepth"
          :depth="depth + 1"
          v-on:child-deletion-requested="removeChild"
        >
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import QueryBuilderRule from "./QueryBuilderRule.vue";
import deepClone from "../utils/deepClone.js";

export default {
  name: "query-builder-group",

  components: {
    QueryBuilderRule,
  },
  data() {
    return {};
  },

  props: [
    "customItems",
    "ruleTypes",
    "type",
    "query",
    "rules",
    "index",
    "maxDepth",
    "depth",
    "slots",
  ],

  methods: {
    generateUUIDv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    addRule() {
      const updated_query = deepClone(this.query);

      const child = {
        type: "query-builder-rule",
        query: {
          rule: this.rules[0].id,
          selectedOperator: this.rules[0].operators[0].value,
          value: "",
          type: this.rules[0].type,
        },
      };
      updated_query.children.push(child);
      this.$emit("update:query", updated_query);
    },

    addGroup() {
      const updated_query = deepClone(this.query);

      if (this.depth < this.maxDepth) {
        updated_query.children.push({
          type: "query-builder-group",
          query: {
            logicalOperator: "AND",
            children: [
              {
                type: "query-builder-rule",
                query: {
                  rule: this.rules[0].id,
                  selectedOperator: this.rules[0].operators[0].value,
                  value: "",
                  type: this.rules[0].type,
                },
              },
            ],
          },
        });
        this.$emit("update:query", updated_query);
      }
    },

    remove() {
      this.$emit("child-deletion-requested", this.index);
    },

    removeChild(index) {
      const updated_query = deepClone(this.query);
      updated_query.children.splice(index, 1);
      this.$emit("update:query", updated_query);
    },
  },

  data() {
    return {};
  },
  computed: {
    hasMultipleRule() {
      return this.query.children.length > 1;
    },
  },
};
</script>
